<template>
    <div class="flex flex-wrap items-center relative -m-2">
          <div class="flex w-full items-center leading-normal p-2">
              <p v-if="rendercontent" class="pb-0 whitespace-pre-wrap" v-on:click="isHidden = !isHidden" v-html="rendercontent" :id="('success_') + theid + routeparam"></p>
              <p v-else class="pb-0 whitespace-pre-wrap text-gray-400 cursor-pointer hover:text-green-500" v-on:click="isHidden = !isHidden"><i aria-hidden="true" class="material-icons text-xl">add_box</i></p>
          </div>
          <template v-if="!isHidden">
            <div class="flex flex-wrap items-center absolute top-0 left-0 right-0 bottom-0 h-full -mx-2" v-click-outside="onClickOutside">
              <textarea class="w-full h-full px-4 py-2 leading-normal border-0 text-black bg-green-100" :id="('textarea_') + theid + routeparam" type="text"
                     v-model="rendercontent"
                     rows="2"
                     v-html="rendercontent"
              >
            </textarea>
            <button :id="theid + routeparam" @click="putItem" type="submit" class="commitbutton absolute top-0 right-0 -mr-8 p-0 inline-block w-10 z-50"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
            </div>
          </template>
        
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
            uniqueid:'',
        },

        data() {
          return {
            isHidden: true,
            isDone: false,
            success: false,
            loaded: true,
            rendercontent: this.content,
            theid: this.uniqueid,
          }
        },
        
        directives: {
          clickOutside: vClickOutside.directive
        },

        methods: {
          
          // clickToFocus: function (event) {
          //   if (this.isHidden) {
          //     this.isHidden = false;
          //     $( document.getElementById("'textarea_'" + this.theid + this.routeparam).focus() );
          //   }
          // },

          // formfocus() {
          //     document.getElementById("'textarea_'" + this.theid + this.routeparam).focus();
          // },
          // mounted(){
          //     this.formFocus();
          // },
          
          onClickOutside (event) {
              this.isHidden = !this.isHidden
          },

          putItem: function (event) {
              $( "#" + this.theid + this.routeparam).addClass( "loading-alt" );
              $( "#success_" + this.theid + this.routeparam).addClass( "successful" );
              axios.put(this.route,
                { [this.routeparam]: this.rendercontent }
              )
              .then(function (response) {
                  console.log(response);
                }).then(data => {
                  this.isHidden = true;
                })
            }

        },
      }
</script>
